// Mirrors backend/app/models/job.py (JobStatus, JobStage) and
// backend/app/schemas/job.py (JobResponse) - keep these in sync.

export type JobStatus =
    | "created"
    | "uploading"
    | "uploaded"
    | "scanning"
    | "rejected"
    | "queued"
    | "processing"
    | "completed"
    | "failed"
    | "expired"
    | "deleted";

export type JobStage =
    | "upload"
    | "validation"
    | "antivirus"
    | "queued"
    | "conversion"
    | "markdown_export"
    | "cleanup"
    | "completed";

export interface ConversionJob {
    job_id: string;
    original_filename: string;
    file_size: number;
    status: JobStatus;
    stage: JobStage;
    progress: number;
    status_message: string | null;
    error_code: string | null;
    error_message: string | null;
    created_at: string;
    updated_at: string;
    expires_at: string;
    started_at: string | null;
    completed_at: string | null;
    download_available: boolean;
}

/** Statuses the UI should stop polling for - the job will not change again. */
export const TERMINAL_STATUSES: readonly JobStatus[] = [
    "completed",
    "failed",
    "rejected",
    "expired",
    "deleted",
];

export function isTerminalStatus(status: JobStatus): boolean {
    return TERMINAL_STATUSES.includes(status);
}
